import { mapConfig } from 'lib/config'
import React, { useMemo } from 'react'

import Marker from '../components/Marker'

export interface PositionMarkerProps {
  id?: string
  lat: number
  lng: number
  zIndex?: number
  onMarkerCreate: (marker: H.map.Marker) => void
}

const { dimensions, style } = mapConfig.markers.position

export function PositionMarker({
  id,
  lat,
  lng,
  zIndex = 1000,
  onMarkerCreate,
}: PositionMarkerProps): JSX.Element {
  const position = useMemo(() => ({ lat, lng }), [lat, lng])
  const markerId = id !== undefined ? id : ''
  return (
    <Marker
      id={markerId}
      position={position}
      zIndex={zIndex}
      width={Number(dimensions.width)}
      height={Number(dimensions.height)}
      top={Number(style.top)}
      left={Number(style.left)}
      onMarkerCreate={onMarkerCreate}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        x="0"
        y="0"
        style={{ left: '-15px', top: '-30px' }}
      >
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20Z"
          fill="#0FA89E"
        />
        <g filter="url(#filter0_d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 20C30 25.5229 25.5229 30 20 30C14.4771 30 10 25.5229 10 20C10 14.4772 14.4771 10 20 10C25.5229 10 30 14.4772 30 20Z"
            fill="white"
          />
          <circle cx="20" cy="20" r="8" fill="#0FA89E" />
          <circle cx="20" cy="20" r="7.5" stroke="#00123E" strokeOpacity="0.3" />
        </g>
        <defs>
          <filter
            id="filter0_d"
            x="6"
            y="6"
            width="28"
            height="28"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.207843 0 0 0 0 0.282353 0 0 0 0 0.439216 0 0 0 0.25 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
        </defs>
      </svg>
    </Marker>
  )
}

export default React.memo(PositionMarker)
